export const PHONE_DISPLAY = "803-616-9473";
export const PHONE_TEL = "tel:+18036169473";
export const SMS_LINK =
  "sms:+18036169473?body=Hi%20Twizted%20Tow%2C%20I%27d%20like%20dump%20trailer%20rental%20pricing.";

export const IMAGES = {
  logo:
    "https://customer-assets-agu9un31.emergentagent.net/job_974ca8cc-3924-4db9-a937-afab7dc78589/artifacts/7fwlrh1g_twiztedtow%20logo.webp",
  heroTruck:
    "https://static.prod-images.emergentagent.com/jobs/974ca8cc-3924-4db9-a937-afab7dc78589/images/60e50384bd27da9c3f28b72452c208d27a4ac158b8e627cb69d20f729d6ad047.jpeg",
  truckSpotlight:
    "https://static.prod-images.emergentagent.com/jobs/974ca8cc-3924-4db9-a937-afab7dc78589/images/b9f76fb49be5da88db142abbf7d12e591085894fa0db5291b35a279c8a75b018.jpeg",
  texture:
    "https://static.prod-images.emergentagent.com/jobs/974ca8cc-3924-4db9-a937-afab7dc78589/images/e5a43ef8f8594fa0e23fadf3dbc3748249e0a13c7b78219f6773bcb34e1725e4.jpeg",
  dumpTrailer:
    "https://static.prod-images.emergentagent.com/jobs/974ca8cc-3924-4db9-a937-afab7dc78589/images/1e5fd9b3ed9388f76200636bba1a20486feecbfb0448b90d04dd0114ad4435f8.jpeg",
};
